module.exports = __webpack_public_path__ + "static/media/ask.bf2c2434.jpg";